import c from 'classnames';
import { BackButton } from '@repo/ui';
import { ProfileQuestionsGroup } from 'types/ProfileQuestions';
import {
  ActivationBackButton,
  ContainerSizes,
  PageContainer,
} from 'components';

import styles from './ProfileHeader.module.css';

export const ProfileHeader = ({
  currentQuestionIdx,
  questions,
  goBack,
  hideProgress = false,
  redesigned = false,
}: {
  currentQuestionIdx: number;
  questions: ProfileQuestionsGroup[];
  goBack?: () => void;
  hideProgress?: boolean;
  redesigned?: boolean;
}) => {
  return (
    <div
      className={c(
        styles.headerContainer,
        redesigned && styles.headerContainerRedesigned,
      )}
    >
      {goBack ? (
        redesigned ? (
          <ActivationBackButton onBack={goBack} />
        ) : (
          <BackButton goBack={goBack} />
        )
      ) : (
        <div className={styles.blankSpace}></div>
      )}
      {!hideProgress && (
        <PageContainer
          size={ContainerSizes.SM}
          className={styles.stepsProgress}
        >
          {questions?.map((s, idx) => (
            <div
              className={c(
                styles.progressMarker,
                idx < currentQuestionIdx && styles.filled,
                idx === currentQuestionIdx && styles.partial,
              )}
              key={idx}
              data-testid='profileProgressMarker'
            ></div>
          ))}
        </PageContainer>
      )}
      <div className={styles.blankSpace}></div>
    </div>
  );
};
